// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_2d_6n grid","Head":"Content__Head_ey8b6 grid","Heading":"Content__Heading_5dWTW","Description":"Content__Description_1Niz8"};